// extracted by mini-css-extract-plugin
export var copyable = "_g-1";
export var explainable = "_g-0";
export var negative = "_g-2";
export var positive = "_g-3";